// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import UploadFilesProgress from './UploadFilesProgress';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';





export default function DocSrcAddDialog(props) {

  const { sysID, open, onClose, docDetail, afterUpdate } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const onCatchPromiseError = (e) => {
    const msg = typeof e === "string" ? e : (e?.errMsg || e?.message || "Unknown Error");
    setErrMsg(msg);
    setShowError(true);
  }

  const [openUploadProgress, setOpenUploadProgress] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const uploadFile = async (aFile) => {
    if (!aFile || aFile.size === 0) return "";
    if (aFile.size > DmsCommon.MAX_FILE_SIZE) {
      throw new Error("File size exceeds 2GB limit!");
    }
    setUploadProgress(0);
    const vFileID = await DmsService.uploadChunkedFilePromise(
      gState.sessionID,
      aFile,
      (progress) => setUploadProgress(progress)
    );
    return vFileID;
  }


  const handleCloseClick = () => {
    initData();

    onClose && onClose();
  }

  const initData = () => {
    setFile(null);

    setValue("fileName", "")
    setValue("remark", "")


  }

  const [file, setFile] = useState(null);

  const handleSelectedUploadFile = (e) => {
    const vFileList = e.target.files;
    console.log("handleSelectedUploadFile", vFileList);

    if (vFileList.length > 0) {
      const vFile = vFileList[0];

      setValue("fileName", vFile.name)

      setFile(vFile);
    }

  }

  // Setup inital form values
  const defaultFormValues = {
    fileName: "",
    remark: "",
  }

  // React Hook the form
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: defaultFormValues
  });

  const watchFileName = watch("fileName");

  const onSubmit = data => {
    // console.log("onSubmit", data);

    if (file && file.size > DmsCommon.MAX_FILE_SIZE) {
      setErrMsg("File size exceeds 2GB limit!");
      setShowError(true);
      return;
    }

    const xFunc = async () => {
      try {
        setUploadProgress(0);
        setOpenUploadProgress(true);
        setShowLoading(true);

        const aFileID = await uploadFile(file);

        await DmsService.docSrcAddPromise(gState.sessionID, sysID, docDetail.DocID,
          aFileID, file.name, file.size, data.remark);

        setShowLoading(false);
        setOpenUploadProgress(false);

        initData();
        afterUpdate && afterUpdate();

      } catch (e) {
        setShowLoading(false);
        setOpenUploadProgress(false);

        console.log('Fail: ', e);

        onCatchPromiseError(e);
      }
    }
    xFunc();

    // setUploadProgress(0);
    // setOpenUploadProgress(true);
    // setShowLoading(true);

    // uploadFile(file)
    //   .then(aFileID => {
    //     return DmsService.docSrcAddPromise(gState.sessionID, sysID, docDetail.DocID, aFileID, file.name, file.size, data.remark);
    //   })
    //   .then(() => {

    //     setShowLoading(false);
    //     setOpenUploadProgress(false);

    //     initData();
    //     afterUpdate && afterUpdate();
    //   })
    //   .catch((e) => {
    //     setShowLoading(false);
    //     setOpenUploadProgress(false);

    //     console.log('Fail: ', e);

    //     setErrMsg(e.errMsg || e.message);
    //     setShowError(true);

    //   })
  }

  const submitBtnRef = useRef();

  const handleFormSubmit = () => {
    submitBtnRef?.current?.click();
  }

  const Input = styled('input')({
    display: 'none',
  });

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="doc-add-source-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <UploadFilesProgress
        open={openUploadProgress}
        overAllProgress={uploadProgress}
        fileCount={1}
        curFileNo={1}
        curFilename={watchFileName}
      />


      <DialogTitle id="alert-dialog-title">
        Add Source
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} component="form" onSubmit={handleSubmit(onSubmit)} >

          <Controller
            name="fileName"
            control={control}
            render={({ field }) =>

              <TextField
                label="Source File"
                required
                fullWidth
                sx={{ m: 1 }}
                {...field}
                InputLabelProps={{ shrink: true, }}
                InputProps={{
                  readOnly: true,
                  endAdornment:
                    <InputAdornment position="end">
                      <label htmlFor="icon-button-add-src-file">
                        <Input id="icon-button-add-src-file" type="file" onChange={handleSelectedUploadFile} />
                        <Button variant="contained" component="span">
                          Select
                        </Button>
                      </label>
                    </InputAdornment>
                }}
              />

            }
          />


          <Controller
            name="remark"
            control={control}
            render={({ field }) =>

              <TextField
                label="Remark"
                fullWidth
                sx={{ m: 1 }}
                {...field}
                InputLabelProps={{ shrink: true, }}
              />

            }
          />






          {/* <Box sx={{ textAlign: 'right', mt: 1 }} >

          </Box> */}

          <Button type="submit" variant="contained" startIcon={<SaveIcon />} disabled={!file} sx={{ display: "none" }} ref={submitBtnRef}  >Save</Button>

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button variant="contained" startIcon={<SaveIcon />} disabled={!file} onClick={handleFormSubmit}   >Save</Button>

      </DialogActions>
    </Dialog>

  );
}

DocSrcAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterUpdate: PropTypes.func,
};
